// import * as crypto from 'crypto';
import { v4 as uuidv4 } from 'uuid';

export function generateCode() {
  // return crypto.randomBytes(16).toString('hex');
  return uuidv4().replaceAll(`-`,'').slice(0,16);
}

